import React from 'react';

const Logout = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8.713" height="6.74">
    <path d="M8.713 4.591H4.12V6.74L0 3.385 4.12 0v1.95h4.593z" fill="#fff" />
  </svg>
);

export default Logout;
